module.exports = __webpack_public_path__ + "img/mobilesystem6.08906ec0.png";